module.exports = __webpack_public_path__ + "img/shopee-ITU-2.dad4d50c.png";